import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {McqModel} from '../../models';
import {StudentMultiSelectMcq} from '../student/StudentMultiSelectMcq';
import {StudentSingleSelectMcq} from '../student/StudentSingleSelectMcq';
import {TeacherMultiSelectMcq} from '../teacher/TeacherMultiSelectMcq';
import {TeacherSingleSelectMcq} from '../teacher/TeacherSingleSelectMcq';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore
}

@observer
export class TeacherMcq extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    makeObservable(this);
  }

  @computed
  get model(): McqModel {
    return JSON.parse(this.props.x9.Contents) as McqModel;
  }

  render() {
    const props = this.props;
    const model = this.model;
    const behavior = model.behavior;
    const id = props.x9.Id;

    if (behavior === 'single-select')
      return (
        <TeacherSingleSelectMcq contentSnapshotId={id}
                                model={model}
                                store={props.store}/>);
    if (behavior === 'multi-select')
      return (
        <TeacherMultiSelectMcq contentSnapshotId={id}
                                model={model}
                                store={props.store}/>);

    return null;
  }
}
